import { DEFAULT_LOCALE, LOCALE_BY_DOMAINS } from 'constants/domainConfig'
import { resolveKeysInObjectsArrays, isEmpty } from './browserHelper'

//encoding the utm_currency cookie value
export const encodingValue = (obj = '') => {
    const value = obj.split('')
    let string = ''
    const len = value.length
    for (let i = 0; i < len; i++) {
        if (i < len - 1) {
            string = string + value[i].charCodeAt() + '-'
        } else {
            string = string + value[i].charCodeAt()
        }
    }
    return string
}

//decoding the utm_currency cookie value
export const decodingValue = obj => {
    const value = obj.split('|')
    const currSymbol = (value[1] && value[1].split('-')) || ''
    let string = ''
    for (let i = 0; i < currSymbol.length; i++) {
        string = string + String.fromCharCode(currSymbol[i])
    }
    string = value[0] + '|' + string
    return string
}

const currencyPrecisionMap = {
    KWD: 2,
    USD: 2,
    INR: 0,
    AED: 0,
    SAR: 0
}
export const getCurrencyFraction = currency => {
    const precision = currencyPrecisionMap[currency] || 0 //Default precision is 0
    switch (precision) {
        case 0:
            return { minimumFractionDigits: 0 }
        default:
            return {
                minimumFractionDigits: precision,
                maximumFractionDigits: precision,
                enabled: true
            }
    }
}
export const getCurrencyByLocale = () => {
    const domain = resolveKeysInObjectsArrays(['location', 'hostname'], window) // window.location.hostname;
    return LOCALE_BY_DOMAINS[domain] || DEFAULT_LOCALE;
}

// todo - Sankalp, should delete not used
// export const getCurrency = (currency = 'INR') => {
//     const langMeta = getLanguageMeta()
//     currency = langMeta.currency
//     return currency
// }

export const getCurrencySymbol = (currencyCode = '', currencyList = {}) => {
    const { top = [], all = [] } = currencyList
    let currencySymbol
    for (let i = 0; i < top.length; i++) {
        if (top[i].code === currencyCode) {
            currencySymbol = top[i].symbol
            break
        }
    }
    if (isEmpty(currencySymbol)) {
        for (let i = 0; i < all.length; i++) {
            if (all[i].code === currencyCode) {
                currencySymbol = all[i].symbol
                break
            }
        }
    }
    return currencySymbol
}

//todo- Sankalp should delete not used
// export const getCurrencyandSymbol = () => {
//     const langMeta = getLanguageMeta()
//     const { currency = 'INR', symbol = '₹' } = langMeta
//     return currency + '|' + symbol
// }

export const getLocaleByCurrency = (currency = 'INR') => {
    const locales = {
        INR: 'en-IN',
        AED: 'en-IN',
        OMR: 'en-IN',
        KWD: 'en-IN',
        BHD: 'en-IN',
        SAR: 'en-IN'
    }
    return locales[currency]
}

export const getCurrencyPrefix = currencyCode => {
    if (!currencyCode) return
    let currencySymbol = Number()
        .toLocaleString(undefined, { style: 'currency', currency: currencyCode })
        .split('0.00')[0]
    return currencySymbol
}

export const convertPrice = ({ price, currencyCode, sellingRate, rate }) => {
    const locale = getLocaleByCurrency(currencyCode)
    const fraction = getCurrencyFraction(currencyCode) //TO-DO currencyPrecisionMap

    let formatted = 'N/A'
    if (price === 'null') {
        return formatted
    }
    let convertedPrice = 0
    if (!isEmpty(currencyCode) && !isEmpty(price)) {
        convertedPrice = Number(Math.round((Number(sellingRate) / Number(rate)) * parseFloat(price.toString(), 10)))
    }
    return (convertedPrice * 1).toString()
}
export const formatCurrency = ({ price, rate, currencyCode, sellingRate, countUp }) => {
    const locale = getLocaleByCurrency(currencyCode)
    const fraction = getCurrencyFraction(currencyCode) //TO-DO currencyPrecisionMap
    let formatted = 'N/A'
    if (price === 'null') {
        return formatted
    }
    if (!isEmpty(currencyCode) && !isEmpty(price)) {
        const convertedPrice = (Number(sellingRate) / Number(rate)) * parseFloat(price.toString(), 10)
        if (countUp) {
            // formatted = convertedPrice

            formatted = parseFloat(convertedPrice, 10).toLocaleString(locale, {
                currency: currencyCode,
                ...fraction
            })
            formatted = parseFloat(formatted.replace(/,/g, ''), 10)
        } else {
            if (fraction.minimumFractionDigits === 0) {
                formatted = parseInt(Math.ceil(convertedPrice), 10).toLocaleString(locale, {
                    style: 'currency',
                    currency: currencyCode,
                    ...fraction
                })
            } else {
                formatted = parseFloat(convertedPrice, 10).toLocaleString(locale, {
                    style: 'currency',
                    currency: currencyCode,
                    ...fraction
                })
            }
        }
    }
    return formatted
}

export const getConversionRate = (currencyCode = '', currencyList = {}) => {
    const { top = [], all = [] } = currencyList
    let converstionRate
    for (let i = 0; i < top.length; i++) {
        if (top[i].code === currencyCode) {
            converstionRate = top[i]
            break
        }
    }
    if (isEmpty(converstionRate)) {
        for (let i = 0; i < all.length; i++) {
            if (all[i].code === currencyCode) {
                converstionRate = all[i]
                break
            }
        }
    }
    return converstionRate
}

export const getCurrencyFromLocalStorage = () => {
    let storageName = 'Curr'
    const currency = JSON.parse(localStorage.getItem(storageName))

    if (!isEmpty(currency) && currency.hotel && currency.hotel.value) {
        let value = currency.hotel.value
        return { currency: value.code, symbol: value.symbol }
    } else {
        return getCurrencyByLocale()
    }
}
